<nb-card class="dialog" [class.dialog--course]="kind === 'course'">
  <!-- one centred line, no lead (course and exercise, Marcel 29.10.2026) -->
  <nb-card-header class="head head--center">
    <div>
      <h4>
        <!-- a format chosen: the next question becomes the title (Marcel, 29.10.2026;
             Moodle too since #235) -->
        {{
          (kind === "course"
            ? format
              ? "pages.creator.startDialog.methodsLabel"
              : "pages.creator.startDialog.courseTitle"
            : "pages.creator.startDialog.exerciseTitle"
          ) | translate
        }}
      </h4>
    </div>
    <button
      type="button"
      class="close al-dialog-close al-relief-icon al-relief-icon--large al-icon--close"
      (click)="close()"
      [attr.aria-label]="'buttons.close' | translate"
    >
      <span class="al-relief-glyph" aria-hidden="true"></span>
    </button>
  </nb-card-header>

  <nb-card-body *ngIf="kind === 'course'">
    <!-- once a format is chosen the choice rolls up out of view; the back
         button below brings it back -->
    <div class="roll" [class.roll--up]="format" [attr.inert]="format ? '' : null" [attr.aria-hidden]="format ? 'true' : null">
    <div class="roll__inner">
    <div class="formats" role="radiogroup" [attr.aria-label]="'pages.creator.startDialog.formatLabel' | translate">
      <div class="formats__grid">
        <button
          type="button"
          class="format"
          role="radio"
          [class.al-pressed]="format === 'elearning'"
          [attr.aria-checked]="format === 'elearning'"
          (click)="pickFormat('elearning')"
          alAnchor="creator.format-elearning"
        >
          <nb-icon class="format__icon" icon="layers-outline"></nb-icon>
          <span class="format__copy">
            <span class="format__title">{{ "pages.creator.startDialog.elearning" | translate }}</span>
            <span class="format__text">{{ "pages.creator.startDialog.elearningText" | translate }}</span>
          </span>
          <span class="format__check" aria-hidden="true"><nb-icon icon="checkmark-outline"></nb-icon></span>
        </button>
        <button
          type="button"
          class="format"
          role="radio"
          [class.al-pressed]="format === 'moodle'"
          [attr.aria-checked]="format === 'moodle'"
          (click)="pickFormat('moodle')"
        >
          <nb-icon class="format__icon" icon="book-outline"></nb-icon>
          <span class="format__copy">
            <span class="format__title">{{ "pages.creator.startDialog.moodle" | translate }}</span>
            <span class="format__text">{{ "pages.creator.startDialog.moodleText" | translate }}</span>
          </span>
          <span class="format__check" aria-hidden="true"><nb-icon icon="checkmark-outline"></nb-icon></span>
        </button>
      </div>
    </div>
    </div>
    </div>

    <button
      *ngIf="format"
      type="button"
      class="step-back"
      (click)="pickFormat(null)"
      [nbTooltip]="'pages.creator.startDialog.changeFormat' | translate"
      [attr.aria-label]="'pages.creator.startDialog.changeFormat' | translate"
    >
      <nb-icon icon="arrow-back-outline"></nb-icon>
      {{ (format === "elearning" ? "pages.creator.startDialog.elearning" : "pages.creator.startDialog.moodle") | translate }}
    </button>

    <section class="methods" *ngIf="format === 'elearning'">
      <div class="methods__grid">
        <button type="button" class="method" disabled>
          <nb-icon class="method__icon" icon="message-square-outline"></nb-icon>
          <span class="method__title">
            {{ "pages.creator.startDialog.aiTitle" | translate }}
            <span class="soon">{{ "pages.creator.start.soon" | translate }}</span>
          </span>
          <span class="method__text">{{ "pages.creator.startDialog.aiText" | translate }}</span>
        </button>
        <button type="button" class="method" [disabled]="!manualAvailable" (click)="byHand()" alAnchor="creator.by-hand">
          <nb-icon class="method__icon" icon="edit-2-outline"></nb-icon>
          <nb-icon *ngIf="manualAvailable" class="method__go" icon="arrow-forward-outline"></nb-icon>
          <span class="method__title">
            {{ "pages.creator.startDialog.blankTitle" | translate }}
            <span *ngIf="!manualAvailable" class="soon">{{ "pages.creator.start.soon" | translate }}</span>
          </span>
          <span class="method__text">{{ "pages.creator.startDialog.blankText" | translate }}</span>
        </button>
      </div>
    </section>

    <section class="moodle-start" *ngIf="format === 'moodle'">
      <nb-icon class="moodle-start__icon" icon="message-square-outline"></nb-icon>
      <span class="moodle-start__copy">
        <span class="moodle-start__title">{{ "pages.creator.startDialog.moodleStartTitle" | translate }}</span>
        <span class="moodle-start__text">{{ "pages.creator.startDialog.moodleStartText" | translate }}</span>
      </span>
      <button nbButton status="primary" type="button" (click)="moodleWithAi()" alAnchor="creator.moodle-ai">
        {{ "pages.creator.startDialog.moodleStart" | translate }}
        <nb-icon icon="arrow-forward-outline"></nb-icon>
      </button>
    </section>

    <!-- only with the type choice; it leaves with the cards -->
    <p class="note note--bottom" *ngIf="!format"><span class="note__lead">{{ noteLead("pages.creator.startDialog.courseNote") }}</span>{{ noteRest("pages.creator.startDialog.courseNote") }}</p>
  </nb-card-body>

  <nb-card-body *ngIf="kind === 'exercise'">
    <!-- the same wide cards as the course types: icon left, arrow right -->
    <div class="formats__grid">
      <button type="button" class="format" (click)="exerciseOnTopic()" alAnchor="creator.exercise-topic">
        <nb-icon class="format__icon" icon="message-square-outline"></nb-icon>
        <span class="format__copy">
          <span class="format__title">{{ "pages.creator.startDialog.topicTitle" | translate }}</span>
        </span>
        <nb-icon class="format__go" icon="arrow-forward-outline"></nb-icon>
      </button>
      <button
        type="button"
        class="format"
        [nbSpinner]="loadingBuckets"
        [disabled]="loadingBuckets"
        (click)="exerciseFromKnowledge()"
        alAnchor="creator.exercise-knowledge"
      >
        <nb-icon class="format__icon" icon="book-outline"></nb-icon>
        <span class="format__copy">
          <span class="format__title">{{ "pages.creator.startDialog.kbTitle" | translate }}</span>
        </span>
        <nb-icon class="format__go" icon="arrow-forward-outline"></nb-icon>
      </button>
    </div>
    <p class="note"><span class="note__lead">{{ noteLead("pages.creator.startDialog.exerciseNote") }}</span>{{ noteRest("pages.creator.startDialog.exerciseNote") }}</p>
  </nb-card-body>
</nb-card>
